import React, { useState, useEffect, useRef } from 'react'
import { MDBBtn, MDBInput, MDBModal, MDBModalBody, MDBModalFooter, MDBModalHeader, MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEnvelope, faClipboardList, faCloudDownloadAlt, faTimes, faPrint } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios'
import VerPedidos from './VerPedidos'
import VerPedidoDetalle from './VerPedidoDetalle';
import CrearInforme from './CrearInforme';
import { NumericFormat } from 'react-number-format';
import useTraeDatos from '../hooks/useTraeDatos';

import moment from 'moment'
// import Tiquete from '../../componentes/Tiquete'  
import Paginacion from './Paginacion'
import BusquedaFechas from './BusquedaFechas'
import { Timeline } from '../../componentes/timeline/Timeline';
import { jsonrepair } from 'jsonrepair';
import { FacturaPedido } from './FacturaPedido';
import { useReactToPrint } from 'react-to-print';
import Tiquete, { ComponentToPrint } from '../../componentes/pos/posBody/pasarelaPago/Tiquete';
// import InformePedidosPdf from './informePedidosPdf'  
// import { CSVLink } from "react-csv";

const Pedidos = ({ titulo, baseUrl, baseUrlProductos, baseUrlSeguimiento, baseUrlCursos, logo, urlCupon, baseUrlActual }) => {

	const [startDate, setStartDate] = useState(new Date());
	const [finalFecha, setFinalFecha] = useState(new Date());
	const [mediosDePago, setMediosDePago] = useState([]);
	const [cuponSel, setCuponSel] = useState('todos');
	const [Cupones] = useTraeDatos(urlCupon)
	const [filtroTipoPedido, setFiltroTipoPedido] = useState('')

	const headers = [
		{ label: "Id", key: "id", },
		{ label: "Factura", key: "codFac" },
		{ label: "Fecha", key: "fecha" },
		{ label: "Estado", key: "estado" },
		{ label: "Total", key: "total" },
		{ label: "Subtotal", key: "subtotal" },
		{ label: "Valor Impuesto", key: "valor_impuesto" },
		{ label: "Descuento", key: "descuento" },
		{ label: "Nombre de impuesto ", key: "impuesto_nombre" },
		{ label: "Importe", key: "importe" },
		{ label: "Medio", key: "medio" },
		{ label: "Referencia", key: "referencia" },
		{ label: "Estado de Medio de Pago", key: "estadoMedio" },
		{ label: "Nombre de descuento Personalizado", key: "nombreDescPersonali" },
		{ label: "Valor de descuento Personalizado", key: "valorDescPersonali" },
		{ label: "Factura Electronica", key: "electronica" },
		{ label: "Cliente", key: "nombre" },
		{ label: "Telefono", key: "telefono" },
		{ label: "Nit", key: "nit" },
		{ label: "Email", key: "email" },
		{ label: "Direccion", key: "direccion" },
		{ label: "Domicilio", key: "domicilio" },
		{ label: "Domiciliario", key: "domiciliario" },
		{ label: "Pedidos", key: "pedidoNombres" },
		{ label: "Precio productos", key: "precio_productos" },
		{ label: "Precio productos rebajado", key: "precio_prod_rebajado" }
	];

	const [data2, setData2] = useState([
		{ firstName: "Warren", lastName: "Morrow", email: "sokyt@mailinator.com", age: "36" }
	]);

	const [estadoPed, setEstadoPed] = useState('todos')

	const [data, setData] = useState([])
	const [dataCopia, setDataCopia] = useState([])
	const [dataFiltrado, setDataFiltrado] = useState([])
	const [pedidoSelect, setPedidoSelect] = useState({ datosPago: {}, pedido: [], cliente: {}, domicilio: { activo: 'false' }, filtroDomi: 'todos', medio: 'todos' })
	const [filtroBusq, setFiltroBusq] = useState({ domicilio: { activo: 'false' }, filtroDomi: 'todos', medio: 'todos' })

	//selecciona la función como eliminar, crear, editar
	const [funcion, setFuncion] = useState('ver')

	//Alerta del error para la validacion de formulario

	const [loading, setLoading] = useState(false)
	const [resultados, setResultados] = useState({})

	const PAGINACION = 40
	const [numPaginas, setNumPaginas] = useState()
	const [numRegistros, setNumRegistros] = useState()
	const [paginaAct, setPaginaAct] = useState(1);

	const [seguimientoPedido, setSeguimientoPedido] = useState([])
	const [modalSeguimientoPedido, setModalSeguimientoPedido] = useState(false)
	const [nuevoSeguimiento, setNuevoSeguimiento] = useState({ nombre: '', correo: '', numeroGuia: '', mensaje: '' })
	const [toastSeguimiento, setToastSeguimiento] = useState({ visible: false, tipo: 'success', mensaje: '' })
	const [guardandoSeguimiento, setGuardandoSeguimiento] = useState(false)
	const [dataCopiaActivacion, setDataCopiaActivacion] = useState([])
	const tiqueteRef = useRef()

	const mostrarToastSeguimiento = (mensaje, tipo = 'success') => {
		setToastSeguimiento({ visible: true, tipo, mensaje })
		setTimeout(() => {
			setToastSeguimiento({ visible: false, tipo: 'success', mensaje: '' })
		}, 3200)
	}

	const estadoEsEnviado = nuevoSeguimiento.nombre === 'Enviado'

	const getSeguimientoInicial = (pedido, seguimiento = []) => {
		const ultimoEnviado = [...seguimiento].reverse().find(item => item.nombre === 'Enviado')
		return {
			nombre: '',
			correo: ultimoEnviado?.correo || pedido?.cliente?.email || '',
			numeroGuia: ultimoEnviado?.numeroGuia || '',
			mensaje: ultimoEnviado?.mensaje || '',
		}
	}

	const Filtro = () => {
		if (filtroTipoPedido === 'Activacion' && estadoPed === 'todos') {
			let NewArr = []
			dataCopiaActivacion.map(item => {
				if (item.canal === 'Activacion') {
					NewArr.push(item)
				}
			})

			setData(NewArr)
			setDataFiltrado([...NewArr].splice(0, PAGINACION))
			setNumPaginas(Math.ceil(NewArr.length / PAGINACION))
			setNumRegistros(NewArr.length)
			setPaginaAct(1)
			return null
		}


		if (filtroTipoPedido === 'Activacion' && estadoPed != 'todos') {
			let NewArr = []
			dataCopiaActivacion.map(item => {
				if (item.canal === 'Activacion' && estadoPed === item.estado) {
					NewArr.push(item)
				}
			})


			setData(NewArr)
			setDataFiltrado([...NewArr].splice(0, PAGINACION))
			setNumPaginas(Math.ceil(NewArr.length / PAGINACION))
			setNumRegistros(NewArr.length)
			setPaginaAct(1)
			return null
		}

		if (estadoPed != 'Todos' && filtroTipoPedido === 'Activacion') {
			let NewArr = []
			dataCopiaActivacion.map(item => {
				if (item.canal === 'Activacion' && estadoPed === item.estado) {
					NewArr.push(item)
				}
			})
			setData(NewArr)
			setDataFiltrado([...NewArr].splice(0, PAGINACION))
			setNumPaginas(Math.ceil(NewArr.length / PAGINACION))
			setNumRegistros(NewArr.length)
			setPaginaAct(1)
			return null
		}


		if (filtroTipoPedido === 'Todos' && estadoPed === 'todos') {
			let NewArr = []
			dataCopia.map(item => {
				NewArr.push(item)
			})
			setData(NewArr)
			setDataFiltrado([...NewArr].splice(0, PAGINACION))
			setNumPaginas(Math.ceil(NewArr.length / PAGINACION))
			setNumRegistros(NewArr.length)
			setPaginaAct(1)
			return null
		}

		if (estadoPed != 'todos' && filtroTipoPedido != 'Activacion') {
			let NewArr = []
			dataCopia.map(item => {
				if (item.canal === filtroTipoPedido && estadoPed === item.estado) {
					NewArr.push(item)
				}
			})
			setData(NewArr)
			setDataFiltrado([...NewArr].splice(0, PAGINACION))
			setNumPaginas(Math.ceil(NewArr.length / PAGINACION))
			setNumRegistros(NewArr.length)
			setPaginaAct(1)
			return null
		}


		if (estadoPed != 'todos') {
			//console.log('hola')
			let NewArr = []
			dataCopia.map(item => {
				if (estadoPed === item.estado) {
					NewArr.push(item)
				}
			})
			setData(NewArr)
			setDataFiltrado([...NewArr].splice(0, PAGINACION))
			setNumPaginas(Math.ceil(NewArr.length / PAGINACION))
			setNumRegistros(NewArr.length)
			setPaginaAct(1)
			return null
		}


		if (filtroTipoPedido != 'Activacion') {
			let NewArr = []
			dataCopia.map(item => {
				if (item.canal === filtroTipoPedido) {
					NewArr.push(item)
				}
			})
			setData(NewArr)
			setDataFiltrado([...NewArr].splice(0, PAGINACION))
			setNumPaginas(Math.ceil(NewArr.length / PAGINACION))
			setNumRegistros(NewArr.length)
			setPaginaAct(1)
			return null
		}


	}

	//Selecciona mediodePago para editarla o borrarla 
	const SeleccionarPedido = (objeto, funcion) => e => {
		if (funcion === 'pedido') {
			setFuncion(funcion)
			setPedidoSelect(objeto)
		}
		if (funcion === 'seguimiento') {
			setNuevoSeguimiento(getSeguimientoInicial(objeto))
			traerSeguimientoPedido(objeto)
			setModalSeguimientoPedido(true)
			setPedidoSelect(objeto)
		}
	}

	const traerSeguimientoPedido = async (pedido) => {
		try {
			const idPedido = pedido?.id
			const { data } = await axios(baseUrlSeguimiento, {
				params: {
					idpedido: idPedido
				}
			})
			setSeguimientoPedido(data)
			setNuevoSeguimiento(prev => ({
				...getSeguimientoInicial(pedido || { cliente: {} }, data),
				nombre: prev.nombre,
			}))
		} catch (error) {
			console.log(error)
		}
	}

	const peticionPut = () => {

		if (pedidoSelect.estado === 'Aprobado' || ((pedidoSelect.estado === 'Pendiente' || pedidoSelect.estado === 'Incompleto' || pedidoSelect.estado === 'Fallido' || pedidoSelect.estado === 'Devolucion') && pedidoSelect.datosPago.motivoCancel !== undefined && pedidoSelect.datosPago.motivoCancel !== "")) {

			let f = new FormData()
			f.append('id', pedidoSelect.id)
			// f.append('codFac', pedidoSelect.codFac)
			// f.append('fecha', pedidoSelect.fecha)
			f.append('estado', pedidoSelect.estado)
			//f.append('total', pedidoSelect.total)
			f.append('datosPago', JSON.stringify(pedidoSelect.datosPago))
			//f.append('pedido', JSON.stringify(pedidoSelect.pedido))
			//f.append('cliente', JSON.stringify(pedidoSelect.cliente))
			f.append('METHOD', 'PUT')

			axios.post(baseUrl, f)
				.then(response => {
					let respuesta = response.data
					let dataNueva = data
					dataNueva.map(item => {
						if (item.id === pedidoSelect.id) {
							item.fecha = pedidoSelect.fecha
							item.estado = pedidoSelect.estado
							item.total = pedidoSelect.total
							item.datosPago = pedidoSelect.datosPago
							item.pedido = pedidoSelect.pedido
							item.cliente = pedidoSelect.cliente
							item.id_stripe = pedidoSelect.id_stripe
						}
					})
					setData(dataNueva)
					setFuncion('ver')
					console.log('enviado')
					//     errores('Limpio')
				}).catch(error => {
					console.log('muestra erro: ' + error);
				})
		} else (alert('No tiene motivo de cancelación'))

	}

	const peticionTraeDatos = async () => {
		let inicioFechaFormat = moment(startDate).format("YYYY-MM-DD")
		await axios.get(baseUrl, { params: { tipo: 'simple', date: inicioFechaFormat } })
			.then(response => {
				let respuesta = response.data

				let newArr = []
				let medios = []
				let newArrayItems = []
				let medioTemp = {}

				FormatearConsulta(respuesta, newArr, medioTemp, medios, newArrayItems)
				let MedioFull = medios.filter((item, index) => { return medios.indexOf(item) === index; })

				setMediosDePago(MedioFull)
				setDataCopiaActivacion(newArrayItems)
				setData(newArr)
				setDataCopia(newArr)
				setDataFiltrado([...newArr].splice(0, PAGINACION))
				setNumPaginas(Math.ceil(newArr.length / PAGINACION))
				setLoading(true)
				setNumRegistros(newArr.length)
			})
			.catch(error => {
				console.log(error)
			})
	}

	const FormatearConsulta = (respuesta, newArr, medioTemp, medios, newArrayItems) => {
		respuesta.map((item) => {
			/*	const datosPago = JSON.parse(item.datosPago);
				const total = parseFloat(item.total)
				if (datosPago.canal === "Activacion" && total > 0) {
	
					let f = new FormData()
					f.append('id', item.id)
					f.append('estado', item.estado)
					f.append('datosPago', JSON.stringify({ ...datosPago, canal: "App" }))
					f.append('METHOD', 'PUT')
					axios.post(baseUrl, f)
					console.log(Object.fromEntries(f.entries()))
				}*/

			medioTemp = item.datosPago !== "" ? JSON.parse(item.datosPago) : ''
			medios.push(medioTemp.medio)

			if (JSON.parse(item.datosPago).canal != "Activacion") {
				newArr.push({
					...item,
					canal: JSON.parse(item.datosPago).canal ? JSON.parse(item.datosPago).canal : 'App',
					datosPago: item.datosPago !== "" ? { ...JSON.parse(item.datosPago), importe: JSON.parse(item.datosPago).mediosPagoPasarela ? JSON.parse(item.datosPago).mediosPagoPasarela[0].importe : 0 } : '',
					pedido: item.pedido !== "" ? JSON.parse(jsonrepair(item.pedido)) : '',
					cliente: item.cliente !== "" ? JSON.parse(item.cliente) : '',
				})
			}

			newArrayItems.push({
				...item,
				canal: JSON.parse(item.datosPago).canal ? JSON.parse(item.datosPago).canal : 'App',
				datosPago: item.datosPago !== "" ? JSON.parse(item.datosPago) : '',
				pedido: item.pedido !== "" ? JSON.parse(jsonrepair(item.pedido)) : '',
				cliente: item.cliente !== "" ? JSON.parse(item.cliente) : '',
				//domicilio: item.domicilio === "" || item.domicilio === undefined ? {} : JSON.parse(item.domicilio)
			})

		})
	}


	const peticionTraeDatosAvanza = async () => {
		setLoading(false)
		let inicioFechaFormat = moment(startDate).format("YYYY-MM-DD")
		let finalFechaFormat = moment(finalFecha).format("YYYY-MM-DD")

		await axios.get(baseUrl, { params: { tipo: 'avanzada', date: inicioFechaFormat, date2: finalFechaFormat } })
			.then(response => {
				let respuesta = response.data
				//console.log('DATA', respuesta)
				let newArr = []
				let newArrayItems = []
				let medios = []
				let medioTemp = {}

				FormatearConsulta(respuesta, newArr, medioTemp, medios, newArrayItems)
				let MedioFull = medios.filter((item, index) => { return medios.indexOf(item) === index; })

				setMediosDePago(MedioFull)
				setData(newArr)
				setDataCopia(newArr)
				setDataFiltrado([...newArr].splice(0, PAGINACION))
				setNumPaginas(Math.ceil(newArr.length / PAGINACION))
				setNumRegistros(newArr.length)
				setLoading(true)
				setDataCopiaActivacion(newArrayItems)
			})
			.catch(error => {
				console.log(error)
			})
	}

	//Trae todas las mediodePagos de la api
	useEffect(() => {
		peticionTraeDatos()
	}, [])

	useEffect(() => {
		Filtro()
	}, [filtroBusq, estadoPed, filtroTipoPedido])

	useEffect(() => {
		//busquedaAvanzada()
		peticionTraeDatosAvanza()
	}, [startDate, finalFecha])

	//agrupar nombres, precios de pedidos
	const AgruparItems = (array, index) => {
		let respu = []
		let Arr = [];

		array.map((item) => {
			Arr = Object.values(item);
			respu.push(Arr[index])
		})

		return respu.toString()
	}

	const PreparaInforme = e => {
		setLoading(false)
		setFuncion('Crear Informe')

		let total = 0
		let taxes = 0
		let envios = 0
		let fechaHoy = moment().format("DD-MM-YYYY")
		let fechaIn = moment(startDate).format("DD-MM-YYYY")
		let FinalFecha = moment(finalFecha).format("DD-MM-YYYY")
		let newArr = []
		let DataOk = []

		// SI tiene un cupon realiza el informe con el cupon seleccionado
		if (cuponSel !== 'todos') {
			DataOk = dataFiltrado
		} else { DataOk = data }

		DataOk.map((item) => {

			if (item.estado == 'Aprobado') {
				total = parseFloat(item.datosPago.total) + total
				taxes = item.datosPago.taxes + taxes
				envios = parseFloat(item.datosPago.totalCargas) + envios
			}
			newArr.push({
				id: item.id,
				fecha: item.fecha,
				estado: item.estado,
				total: item.datosPago.total,
				envios: item.datosPago.totalCargas,
				subtotal: item.datosPago.subtotal,
				taxes: item.datosPago.taxes,
				nombre: item.cliente.nombre,
				telefono: item.cliente.tel,
				email: item.cliente.email,
				direccion: item.cliente.direccion,
				pedidoNombres: item.pedido,
				precio_productos: AgruparItems(item.pedido, 2),
				precio_prod_rebajado: AgruparItems(item.pedido, 3),

			})

		})
		setResultados({
			total: total,
			fechaHoy: fechaHoy,
			taxes: taxes,
			fechaIn: fechaIn,
			fechaFin: FinalFecha,
			envios: envios
		})
		setData2(newArr)
		setLoading(true)
	}

	const RecibeCupon = termino => {
		setCuponSel(termino)
		filtrarCupon(termino)
	}

	const filtrarCupon = (termino) => {
		let arrayNuevo = []
		if (termino === 'todos') {
			setDataFiltrado([...dataCopia].splice(0, PAGINACION))
		} else {
			dataCopia.map(item => {
				if (item.datosPago.cupon !== undefined) {
					if (item.datosPago.cupon && item.datosPago.cupon.toLowerCase() === termino.toLowerCase()) {
						arrayNuevo.push(item)
					}
				}
			})

			setDataFiltrado(arrayNuevo)
		}
	}

	const crearNuevoEstadoSeguimiento = async (e) => {
		e.preventDefault()
		if (!nuevoSeguimiento.nombre) {
			mostrarToastSeguimiento('Debes seleccionar un estado.', 'error')
			return
		}

		if (estadoEsEnviado) {
			if (!nuevoSeguimiento.correo || !/\S+@\S+\.\S+/.test(nuevoSeguimiento.correo)) {
				mostrarToastSeguimiento('Debes ingresar un correo valido para el envio.', 'error')
				return
			}

			if (!nuevoSeguimiento.numeroGuia) {
				mostrarToastSeguimiento('Debes ingresar el numero de guia.', 'error')
				return
			}
		}

		setGuardandoSeguimiento(true)
		try {
			let formData = new FormData();
			formData.append('fecha', moment().format("YYYY-MM-DD HH:mm:ss"))
			formData.append('idPedido', pedidoSelect.id)
			formData.append('nombre', nuevoSeguimiento.nombre)
			formData.append('correo', nuevoSeguimiento.correo)
			formData.append('numeroGuia', nuevoSeguimiento.numeroGuia)
			formData.append('mensaje', nuevoSeguimiento.mensaje)
			formData.append('clienteNombre', pedidoSelect?.cliente?.nombre || '')
			formData.append('METHOD', 'POST')
			const { data } = await axios.post(baseUrlSeguimiento, formData);
			setSeguimientoPedido(data.timeline || [])

			if (nuevoSeguimiento.nombre === 'Enviado') {
				mostrarToastSeguimiento(data.message || 'El mensaje se ha enviado.', data.correoEnviado ? 'success' : 'error')
			} else {
				mostrarToastSeguimiento(data.message || 'El estado fue actualizado correctamente.', 'success')
				setModalSeguimientoPedido(false)
			}
		} catch (error) {
			console.log(error)
			mostrarToastSeguimiento(error?.response?.data?.message || 'No fue posible actualizar el seguimiento.', 'error')
		} finally {
			setGuardandoSeguimiento(false)
		}
	}

	const handleBuscarPedido = (e) => {
		let busqueda = e.target.value.toLowerCase()

		if (!busqueda) {
			return setDataFiltrado([...dataCopia].splice(0, PAGINACION))
		}
		busqueda = busqueda.replace('blue-', '');
		let arrayNuevo = []

		dataCopia.map(item => {
			if (item.datosPago.cupon !== undefined) {
				if (item.id && item.id.toLowerCase() === busqueda) {
					arrayNuevo.push(item)
				}
			}
		})

		setDataFiltrado(arrayNuevo)
	}

	const componentRef = useRef();
	const handlePrint = useReactToPrint({
		content: () => componentRef.current,
	});


	const handleTiquetePrint = useReactToPrint({
		content: () => tiqueteRef.current,
	});
	return (
		<React.Fragment>
			<div style={{ display: 'flex', width: '100%' }}>
				<div style={{ display: 1 }}><br /><h2>{titulo}</h2>
				</div>
				<div style={{ display: 1 }}>
					<div className="filtroPedidos" style={{ display: 'flex', width: '100%' }}>

						<button
							onClick={PreparaInforme}
							className="btn boton_estandar_blanco float-right"
						><FontAwesomeIcon icon={faClipboardList} size="lg" />
						</button>

						<BusquedaFechas
							startDate={startDate}
							setStartDate={setStartDate}
							finalFecha={finalFecha}
							setFinalFecha={setFinalFecha}
						/>

					</div>

				</div>

			</div>
			<hr />

			<div>

				{funcion === 'pedido' ?

					<div className="row">
						<div className="col-md-4 ">
							<h3>Detalles del pedido:</h3>
						</div>
						<div className="col">
							<button
								onClick={handleTiquetePrint}
								className="btn boton_estandar float-right">
								Imprimir Tiquete
							</button>
							<button
								onClick={e => setFuncion('ver')}
								className="btn boton_estandar float-right">
								Salir
							</button>
							<button
								onClick={peticionPut}
								className="btn boton_estandar float-right">
								Guardar
							</button>
							<button
								onClick={handlePrint}
								className="btn boton_estandar float-right">
								Imprimir
							</button>

							{/* {pedidoSelect.estado !== 'cancelado' ?
						        <button 
									onClick={e => setFuncion('imprimir')}
									className="btn boton_estandar_blanco float-right"							
									><FontAwesomeIcon icon={faPrint} size="lg"/>
								</button>

						    :null} */}
						</div>
					</div>
					: null}

			</div>

			{!loading ?
				<div className="loader">Loading...</div>
				:
				<div>
					{funcion === 'ver' ?
						<div className="row" style={{ paddingLeft: 15, paddingRight: 20 }}>
							<div className="col-md-3">
								<input className="form-control" type="text" placeholder="Buscar Pedido" onChange={handleBuscarPedido} />
							</div>
							<div className="col-md-3">
								<select
									style={{ width: '50px !important' }}
									className="browser-default custom-select selectAtri"
									value={estadoPed}
									onChange={e => setEstadoPed(e.target.value)}>
									<option value="todos">Filtra Estado</option>
									<option value="todos">Todos</option>
									<option value="Aprobado">Aprobado</option>
									<option value="Incompleto">Incompleto</option>
								</select>
							</div>



							<div className="col-md-3">
								<select
									style={{ width: '50px !important' }}
									className="browser-default custom-select selectAtri"
									value={cuponSel}
									onChange={e => RecibeCupon(e.target.value)}>
									<option value="todos">Filtra Cupón</option>
									<option value="todos">Todos</option>
									{Cupones.map(item => {
										return (
											<option key={item.id} value={item.codigo}>{item.codigo}</option>
										)
									})}
								</select>
							</div>

							<div className="col-md-3">
								<select
									style={{ width: '50px !important' }}
									className="browser-default custom-select selectAtri"
									value={filtroTipoPedido}
									onChange={e => setFiltroTipoPedido(e.target.value)}>
									<option value="Todos">Filtro Tipo</option>
									<option value="App">App</option>
									<option value="Facturación">Tienda Física</option>
									<option value="Tienda">Página web</option>
									<option value="Activacion">Activaciones</option>
								</select>
							</div>

							<div className="col-md-2">
								<span>Registros:</span><br></br>
								<span>{numRegistros}</span>
							</div>
							<div className="col-md-10">
								<Paginacion
									data={data}
									setDataFiltrado={setDataFiltrado}
									PAGINACION={PAGINACION}
									numPaginas={numPaginas}
									paginaAct={paginaAct}
									setPaginaAct={setPaginaAct}
								/>
							</div>
							<div className="col-md-12 ">

								{/* VER PEDIDOS --------------------- */}
								<VerPedidos dataFiltrado={dataFiltrado} SeleccionarPedido={SeleccionarPedido} />
							</div>
						</div>
						: null}
					{/* VER DETALLE DE PEDIDOS --------------------- */}
					{funcion === 'pedido' ?

						<VerPedidoDetalle
							baseUrl={baseUrlActual}
							pedidoSelect={pedidoSelect}
							baseUrlProductos={baseUrlProductos}
							baseUrlCursos={baseUrlCursos}
							setPedidoSelect={setPedidoSelect}
						/>

						: null}
					{funcion === 'imprimir' ?
						<div className="container">
							<center>
								<button
									onClick={e => setFuncion('ver')}
									className="btn boton_estandar">
									Salir
								</button>
								{/* <Tiquete 
				          		datosFactura={pedidoSelect}
				          		config={config}					
				          	/> */}
							</center>
						</div>
						: null}

					{funcion === 'Crear Informe' ?
						<CrearInforme
							setFuncion={setFuncion}
							logo={logo}
							data2={data2}
							resultados={resultados}
						/>
						: null}
				</div>
			}

			<div style={{ display: "none" }}><FacturaPedido ref={componentRef} data={pedidoSelect} /></div>

			<div style={{ display: "none" }}><ComponentToPrint ref={tiqueteRef} datosFactura={pedidoSelect} selectDomi={[]} /></div>

			{toastSeguimiento.visible ? (
				<div
					style={{
						position: 'fixed',
						top: 20,
						right: 20,
						zIndex: 2000,
						minWidth: 280,
						maxWidth: 360,
						padding: '14px 18px',
						borderRadius: 12,
						backgroundColor: toastSeguimiento.tipo === 'success' ? '#2e7d32' : '#c62828',
						color: '#fff',
						boxShadow: '0 8px 24px rgba(0,0,0,0.18)'
					}}
				>
					{toastSeguimiento.mensaje}
				</div>
			) : null}

			<MDBModal isOpen={modalSeguimientoPedido} toggle={() => setModalSeguimientoPedido(!modalSeguimientoPedido)}>
				<MDBModalHeader toggle={() => setModalSeguimientoPedido(!modalSeguimientoPedido)}>Seguimiento de pedido</MDBModalHeader>
				<MDBModalBody>
					<Timeline data={seguimientoPedido} />
					<hr />
					<form className="text-center p-3" onSubmit={crearNuevoEstadoSeguimiento}>
						<p className="h4 mb-3">Crear estado</p>
						<select
							className="browser-default custom-select mb-3"
							name='nombre'
							value={nuevoSeguimiento.nombre}
							onChange={e => setNuevoSeguimiento(prev => ({ ...prev, nombre: e.target.value }))}
							required>
							<option value="">Selecciona un estado</option>
							<option value="Pedido generado exitosamente">Pedido generado exitosamente</option>
							<option value="En alistamiento">En alistamiento</option>
							<option value="Enviado">Enviado</option>
							<option value="Entregado">Entregado</option>
						</select>
						{estadoEsEnviado ? (
							<div className="text-left">
								<label className="mb-1 font-weight-bold">Correo para el envio</label>
								<input
									className="form-control mb-3"
									type="email"
									value={nuevoSeguimiento.correo}
									onChange={e => setNuevoSeguimiento(prev => ({ ...prev, correo: e.target.value }))}
									placeholder="cliente@correo.com"
									required
								/>
								<label className="mb-1 font-weight-bold">Numero de guia</label>
								<input
									className="form-control mb-3"
									type="text"
									value={nuevoSeguimiento.numeroGuia}
									onChange={e => setNuevoSeguimiento(prev => ({ ...prev, numeroGuia: e.target.value }))}
									placeholder="Ingresa el numero de guia"
									required
								/>
								<label className="mb-1 font-weight-bold">Mensaje para el cliente</label>
								<textarea
									className="form-control mb-3"
									rows="4"
									value={nuevoSeguimiento.mensaje}
									onChange={e => setNuevoSeguimiento(prev => ({ ...prev, mensaje: e.target.value }))}
									placeholder="Escribe aqui el mensaje que recibira el cliente."
								/>
								<p className="text-muted mb-3" style={{ fontSize: 14 }}>
									Si el pedido ya fue marcado como enviado, puedes volver a presionar el boton para reenviar el correo.
								</p>
							</div>
						) : null}
						<MDBBtn color="secondary" type="button" onClick={() => setModalSeguimientoPedido(!modalSeguimientoPedido)}>Cerrar</MDBBtn>
						<MDBBtn color="primary" type='submit' disabled={guardandoSeguimiento}>
							{guardandoSeguimiento ? 'Guardando...' : 'Crear nuevo estado'}
						</MDBBtn>
					</form>

				</MDBModalBody>
			</MDBModal>
		</React.Fragment>
	)
}

export default Pedidos
